<div class="pl-0 mb-5 sm:pl-6 sm:mb-0">
	<h1 class="text-2xl font-bold tracking-tight text-black sm:text-2xl">
		{{ courseName() }}
	</h1>
	<div class="flex items-center">
		<uc-office-svg customStyles="sm:hidden mr-1.5 w-4 h-4 text-gray-600" />
		<a [routerLink]="link()">
			<p class="text-base text-gray-500 cursor-pointer">
				<span class="underline blue-link">{{ uniName() }}</span>
			</p>
		</a>
	</div>
</div>
